import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import GppGoodIcon from '@mui/icons-material/GppGood'
import { useTranslation } from 'react-i18next'

type ProposalProtectedInfoProps = {
  isProtected: boolean
}

const ProposalProtectedInfo: React.FC<ProposalProtectedInfoProps> = ({ isProtected }) => {
  const { t } = useTranslation()

  if (!isProtected) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        mt: 2,
        px: 2,
        width: '100%',
        maxWidth: { md: 443 }
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontWeight: 'fontWeightMedium', mb: 0.5 }}>
          {t('proposal-is-protected')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('request-for-proposal-proposal-viewing-locked')}
        </Typography>
      </Box>
      <GppGoodIcon sx={{ color: 'primary.main', fontSize: 40, flexShrink: 0, mt: 0.5 }} />
    </Box>
  )
}

export default ProposalProtectedInfo

